// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"2e0595e7","369":"64d50bd3","848":"31f197db","867":"b156f36c"}[chunkId] + ".chunk.css";
};